export const SET_MODAL_KEEP_WATCHING = 'SET_MODAL_KEEP_WATCHING';

export const setDataModalKeepWatching = (payload) => (dispatch) => {
    dispatch({
        type: SET_MODAL_KEEP_WATCHING,
        payload,
    });
};



// WEBPACK FOOTER //
// ./src/actions/modalKeepWatching.js